import type { ReactNode } from "react";

/** A centered card that takes the whole page, for a message with its actions. */
export default function FullPageMessage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-lg shadow text-center">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {children}
      </div>
    </div>
  );
}
